module.exports = __webpack_public_path__ + "static/49-9665413ac80ccca0046ac9c1db1a4836.png";